export default "__VITE_ASSET__DFlWJxW4__"